import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useSaveDefaultPlan = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const planFromUrl = params.get("plan");

    if (planFromUrl) {
      localStorage.setItem("default_plan", planFromUrl);
      params.delete("plan");
      const cleanUrl = `${location.pathname}${
        params.toString() ? `?${params.toString()}` : ""
      }`;
      navigate(cleanUrl, { replace: true });
    }
  }, [location, navigate]);
};
